import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { LocationPageComponent } from './pages/location-page/location-page.component';
import { SelectUnitPageComponent } from './pages/select-unit-page/select-unit-page.component';
import { UnitReservedPageComponent } from './pages/unit-reserved-page/unit-reserved-page.component';
import { ForeignNationalPageComponent } from './pages/foreign-national-page/foreign-national-page.component';
import { FacilityStandardsPageComponent } from './pages/facility-standards-page/facility-standards-page.component';
import { SecurityPageComponent } from './pages/security-page/security-page.component';
import { MovingTipsPageComponent } from './pages/moving-tips-page/moving-tips-page.component';
import { FaqsPageComponent } from './pages/faqs-page/faqs-page.component';
import { ContactPageComponent } from './pages/contact-page/contact-page.component';
import { VipPageComponent } from './pages/vip-page/vip-page.component';
import { PaymentTermsPageComponent } from './pages/payment-terms-page/payment-terms-page.component';
import { FreeMovePageComponent } from './pages/free-move-page/free-move-page.component';
import { PrivacyStatementPageComponent } from './pages/privacy-statement-page/privacy-statement-page.component';
import { WrongRoutePageComponent } from './pages/wrong-route-page/wrong-route-page.component';
import { CareersPageComponent } from './pages/careers-page/careers-page.component';
import { BlogPageComponent } from './pages/blog-page/blog-page.component';
import { ArticlePageComponent } from './pages/article-page/article-page.component';
import { ReferAFriendPageComponent } from './pages/refer-a-friend-page/refer-a-friend-page.component';
import { EbookMovingChecklistPageComponent } from './pages/ebook-moving-checklist-page/ebook-moving-checklist-page.component';
import { EbookGetMoreSpacePageComponent } from './pages/ebook-get-more-space-page/ebook-get-more-space-page.component';
import { RentNowPageComponent } from './pages/rent-now-page/rent-now-page.component';
import { FurnitureStoragePageComponent } from './pages/furniture-storage-page/furniture-storage-page.component';
import { CarStorageUnitsAndParkingBaysPageComponent } from './pages/car-storage-units-and-parking-bays-page/car-storage-units-and-parking-bays-page.component';
import { WhatsappTestPageComponent } from './pages/whatsapp-test-page/whatsapp-test-page.component';
const routes: Routes = [
	{ path: '', component: HomePageComponent },
	{ path: 'contact', component: ContactPageComponent },
	{ path: 'vip', component: VipPageComponent },
	{ path: 'faqs', component: FaqsPageComponent },
	{ path: 'moving-tips', component: MovingTipsPageComponent },
	{ path: 'security', component: SecurityPageComponent },
	{ path: 'blog', component: BlogPageComponent },
	{ path: 'blog/:id', component: ArticlePageComponent },
	{ path: 'facility-standards', component: FacilityStandardsPageComponent },
	{ path: 'storage-facility/:location', component: LocationPageComponent },
	{ path: 'storage-facility/:location/storage-units/:size', redirectTo: '/storage-facility/:location/:size' },
	{ path: 'storage-facility/:location/:unit_id', component: SelectUnitPageComponent },
	{ path: 'reserved/:reservation', component:UnitReservedPageComponent },
	{ path: 'foreign-national/:location', component:ForeignNationalPageComponent },
	{ path: 'payment-terms', component: PaymentTermsPageComponent },
	{ path: 'free-move-in-transport', component: FreeMovePageComponent },
	{ path: 'privacy-statement', component: PrivacyStatementPageComponent },
	{ path: 'careers', component: CareersPageComponent },
	{ path: 'refer', component: ReferAFriendPageComponent },
	{ path: 'ebook/moving-checklist', component: EbookMovingChecklistPageComponent },
	{ path: 'ebook/get-more-space', component: EbookGetMoreSpacePageComponent },
	{ path: 'rent-now', component: RentNowPageComponent },
	{ path: 'rentnow', redirectTo: '/rent-now' },
	{ path: 'furniture-storage', component: FurnitureStoragePageComponent },
	{ path: 'car-storage-units-and-parking-bays', component: CarStorageUnitsAndParkingBaysPageComponent },
	{ path: 'whatsapptest', component: WhatsappTestPageComponent },

	{ path: '404', component: WrongRoutePageComponent },
	{ path: '**', redirectTo: '/404' }
]

const routerOptions: ExtraOptions = {
    useHash: false,
    anchorScrolling: 'enabled',
    onSameUrlNavigation: 'reload',
    initialNavigation: 'enabledBlocking'
}

@NgModule({
	imports: [RouterModule.forRoot(routes, routerOptions)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
